/**
 * Every event this app is allowed to send. Anything not listed here is dropped
 * client-side before it reaches the network — see event-allowlist.ts.
 *
 * The first block mirrors GTM's real, live values (common/google-tag-manager/
 * constants.ts) so a PostHog event and its GTM twin share one string.
 */
export enum AnalyticsEvent {
  ACCOUNT_CREATED = "account_created",
  SIGN_UP = "sign_up",
  LOGIN = "login",
  ALERT_CREATED = "alert_created",
  FEATURED_PORTFOLIO_SAVED = "featured_portfolio_saved",
  FEATURED_PORTFOLIO_UNSAVED = "featured_portfolio_unsaved",
  FILE_DOWNLOAD = "file_download",
  PORTFOLIO_CREATED = "portfolio_created",
  PROPERTY_ADDED_TO_PORTFOLIO = "property_added_to_portfolio",
  PROPERTY_ADDED_TO_TRACKING = "property_added_to_tracking",
  PROPERTY_REMOVED_FROM_TRACKING = "property_removed_from_tracking",
  PROPERTY_SEARCH_USED = "property_search_used",
  PROPERTY_VIEWED = "property_viewed",

  EMAIL_VERIFIED = "email_verified",
  SIGNUP_PROFILE_COMPLETED = "signup_profile_completed",
  PROMO_CODE_APPLIED = "promo_code_applied",

  PAYWALL_SHOWN = "paywall_shown",
  CHECKOUT_STARTED = "checkout_started",
  PURCHASE_COMPLETED = "purchase_completed",
  SUBSCRIPTION_CHANGED = "subscription_changed",
  TRIAL_CANCELED = "trial_canceled",
  BILLING_PORTAL_OPENED = "billing_portal_opened",
  ONBOARDING_CHECKLIST_ITEM_COMPLETED = "onboarding_checklist_item_completed",
  PROPERTY_DETAIL_VIEWED = "property_detail_viewed",
  SHARED_CONTENT_VIEWED = "shared_content_viewed",
  PORTFOLIO_SHARE_LINK_COPIED = "portfolio_share_link_copied",
  LEAD_FORM_OPENED = "lead_form_opened",
  LEAD_SUBMITTED = "lead_submitted",
  EXCHANGE_FEED_CREATED = "exchange_feed_created",
}

/** PostHog's own events that must survive the allowlist. */
export const POSTHOG_INTERNAL_EVENTS = [
  "$pageview",
  "$pageleave",
  "$identify",
  "$set",
  "$create_alias",
  "$groupidentify",
  "$dead_click",
] as const;
